import styled from "styled-components";
import { H2 } from "../style-comps/Common.styles";
import { keyframes } from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-x: auto;
  background-color: #fff;
  border-radius: 32px;
  height: calc(90vh - 40px);
  margin: 20px;

  @media (max-width: 768px) {
    border-radius: 0;
    margin: 0;
  }
    
`;

export const CalendarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow-x: auto;
  width: 100%;
  
  
`;

export const CalenderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  
  
`;

export const HeaderWrapper = styled.div`
  display: flex;
  z-index: 99;
overflow: visible;
position: relative;
  align-items: center;
  justify-content: start;
  padding: 20px;
  background-color: white;
  position: sticky;
  top: 0;
  border-bottom: 1px solid #ddd;

  @media (max-width: 768px) {
  justify-content: space-between;
    
  }
`;

export const CalH2 = styled(H2)`
width:180px;

@media (max-width: 768px) {
    font-size: 18px;
    }
`;

export const CalendarHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
`;



export const ButtonGroup = styled.div`
  display: flex;
  align-items: center;

  button {
    padding: 8px 12px;
    border: 1px solid #ddd;
    background: #fff;
    cursor: pointer;
    margin-left: 5px;

    &:hover {
      background: #f0f0f0;
    }
  }
`;

export const ArrowButton = styled.button`
  padding: 8px 12px;
  background-color: #61cbc9;
  border: none;
  border-radius: 5px;
  color: white;
  font-size: 18px;
  cursor: pointer;
  transition: 0.3s;
  margin: 0 10px;
  
  &:hover {
    background-color: #4aa8a6;
  }
`;

export const MonthYearDisplay = styled.div`
  text-align: left;
  font-size: 1.5em;
  font-weight: bold;
  padding: 10px 20px;
  border-bottom: 1px solid #ddd;
`;

export const ScrollableRow = styled.div`
  display: flex;
  overflow-x: auto;
  width: 100%;
  scrollbar-width: none;
  -ms-overflow-style: none;
  border: 1px solid #ddd;
  border-left: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const PlaceholderCell = styled.div`
  flex: 0 0 200px;
  border-right: 1px solid #ddd;
`;

export const ListingsWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-end;
  overflow: visible; 
`;

export const ListingsColumn = styled.div`
  flex: 0 0 200px;
  max-width: 200px;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  border-right: 1px solid #ddd;
  background-color: #f9f9f9;


  @media (max-width: 768px) {
    font-size: 12px;
    max-width: 160px;
  

    img {
      width: 60px;
      height: auto;
    }
  }
`;

export const CalendarScrollableArea = styled.div`
  overflow-x: visible;   
  overflow-y: visible;
  min-width: 0;
  position: relative;
`;


export const CalendarGrid = styled.div`
 display: flex;
  height: 60px;
  width: 100%;
`;

export const DayCellWrap = styled.div`
  flex: 1;
  min-width: 60px;
  flex-shrink: 0;
  height: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: 0.2px solid #ddd;

  background-color: ${({ isToday, isWeekend }) => {
    if (isToday) return "rgba(253, 219, 50, 0.2)";
    if (isWeekend) return "rgb(240, 248, 255)";
    return "transparent";
  }};

  color: ${(props) => (props.isBooked ? "#0c4128" : "#000")};
  font-size: 12px;

  .date {
    font-size: 14px;
    font-weight: bold;
  }

  .weekday {
    font-size: 10px;
    color: #555;
  }
`;


export const ErrorWarp = styled.div`
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin:auto;
`;

export const ErrorImg = styled.img`
   width:150px;
`;
export const ErrorP = styled.h1`
    font-size: 18px;
    font-weight: bold;
    color: #61cbc9;
`;



export const DayCell = styled.div`
  position: relative; 
  min-width: 60px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: 0.2px solid #ddd;
  background-color: ${({ isToday, isWeekend, status }) => {
    if (status === "unavailable") return "#e0e0e0";
    if (isToday) return "rgba(253, 219, 50, 0.2)";
    if (isWeekend) return "rgb(240, 248, 255)";
    return "#fff";
  }};
  color: ${(props) => (props.isBooked ? "#0c4128" : "#000")};
  font-size: 12px;
  height: 60px;

`;



export const StatusBadge = styled.span`
  display: inline-block;
  margin-top: 5px;
  margin-bottom:4px;
  padding: 4px 6px;
  border-radius: 16px;
  font-size: 12px;
  color: ${(props) => (props.status === "booked" ? "#fff" : "#000")};
  background: ${(props) => (props.status === "booked" ? "#FF6600" : "#fff")};
`;

export const NoteTooltip = styled.div`
    position: absolute;
    bottom: 0%;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.8);
    color: #fff;
    padding: 6px 10px;
    font-size: 12px;
    border-radius: 5px;
    white-space: nowrap;
    opacity: 0;
    transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
    visibility: hidden;
    pointer-events: none;
    z-index:99;

    ${DayCell}:hover & {
        opacity: 1;
        visibility: visible;
        pointer-events: auto;
    }
`;




export const DayWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const ListingsRow = styled.div`
  display: flex;
  align-items: center;
  height: 60px;
  min-height: 60px;
  padding: 10px;
  border-bottom: 1px solid #ddd;
`;

export const ListingImage = styled.img`
  width: 80px;
  height: 50px;
  min-width: 80px;
  min-height: 50px;
  max-width: 80px;
  max-height: 50px;
  object-fit: cover;
  border-radius: 4px;
  margin-right: 10px;
`;



export const ListingName = styled.a`
  text-decoration: none;
  color: #000;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    text-decoration: underline;
  }
`;

export const Listingsub = styled.p`
  color: #0e0e0e;
  font-size: 12px;
`;

/* 旋轉動畫 */
const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

/* Loading 容器 */
export const LoadingWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
    height: 84vh;
    width: 73vw;
    font-size: 20px;
    font-weight: bold;
    color: #61cbc9;
    background-color: white; 
    flex-direction: column;
    gap: 20px;
    border-radius: 32px;

    model-viewer {
        width: 150px;
        height: 150px;
    }

    @media (max-width: 768px) {
        width: 100vw;
    }
`;


/* Loading Icon */
export const LoadingIcon = styled.div`
    width: 24px;
    height: 24px;
    margin-left: 10px;
    border: 3px solid #61cbc9;
    border-radius: 50%;
    border-top-color: transparent;
    animation: ${spin} 1s linear infinite;
`;

export const ResponsiveDropdownWrapper = styled.div`
display: block;
  position: relative;       
  z-index: 20;           
  overflow: visible;

  @media (max-width: 768px) {
    display: none;      
  }
`;

// 🆕 Toast 通知容器
export const ToastContainer = styled.div`
  position: fixed;
  width: auto;
  height: auto;
  right: 20px;
  top: 80px;
  background-color: ${props => props.isError ? '#dc3545' : '#61CBC9'};
  color: ${props => props.isError ? 'white' : 'black'};
  padding: 16px 40px 16px 24px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 100001;
  min-width: 300px;
  max-width: 400px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  animation: slideInFromTop 0.3s; 
  flex-direction: column;
  font-size: 14px;
  font-weight: 500;
  white-space: pre-line;

  @keyframes slideIn {
    from {
      transform: translateX(400px);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
`;

// 🆕 Toast 關閉按鈕
export const ToastCloseButton = styled.button`
position: absolute; 
top: 12px;
right: 12px;
  background: none;
  border: none;
  color: ${props => props.isError ? 'white' : 'black'};
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    opacity: 0.7;
  }
`;

// 🆕 右上角更新指示器
export const UpdateIndicator = styled.div`
  position: fixed;
  top: 150px;
  right: 20px;
  background-color: #61CBC9;
  color: black;
  padding: 10px 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 100000;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  animation: fadeIn 0.3s;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

// 🆕 旋轉 Loading 圖示
export const SpinnerIcon = styled.div`
  width: 16px;
  height: 16px;
  border: 2px solid black;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

// 🆕 格子更新覆蓋層
export const UpdatingOverlay = styled.div`
  position: absolute;
  inset: 0;
  background-color: rgba(97, 203, 201, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  pointer-events: none;
`;

// 🆕 格子內的 Loading 圖示
export const CellSpinner = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid #61CBC9;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

// 🆕 為 DayCell 加入動畫支援
export const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
`;

export const LoadingText = styled.p`
  font-size: 20px;
  color: #61CBC9;
  font-weight: bold;
`;


export const SyncButton = styled.button`
  background-color: #61cbc9;
  border: none;
  padding: 6px;
  border-radius: 6px;
  margin-left: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
  cursor: ${({ isRefreshing }) => (isRefreshing ? 'not-allowed' : 'pointer')};
  opacity: ${({ isRefreshing }) => (isRefreshing ? 0.6 : 1)};

  &:hover {
    background-color: #4aa8a6;
  }
`;

export const SyncButtonIcon = styled.img`
  width: 16px;
  height: 16px;
  transition: transform 0.6s linear;
  transform: ${({ isRefreshing }) => (isRefreshing ? 'rotate(360deg)' : 'rotate(0deg)')};
  animation: ${({ isRefreshing }) => (isRefreshing ? 'spin 0.8s linear infinite' : 'none')};

  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(-360deg); }
  }
`;

export const ReservationBlockLayer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  z-index: 20;
  pointer-events: none;
  overflow: visible;
`;

export const PopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 99999;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: auto;

  /* 手機：留左右安全邊距，避免 popup 貼齊螢幕兩側 */
  @media (max-width: 768px) {
    padding: 16px;
    box-sizing: border-box;
  }
`;

export const PopupContent = styled.div`
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  padding: 20px;
  pointer-events: auto;

  @media (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    max-height: 90vh;
    overflow-y: auto;
    padding: 16px;
    box-sizing: border-box;
  }
`;

export const DayCellBlockLabel = styled.p`
  position: absolute;
  bottom: 4px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  font-size: 10px;
  font-weight: 600;
  color: #555;
  margin: 0;
`;

export const DayCellLabel = styled.p`
  position: absolute;
  bottom: 4px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  font-size: 12px;
  font-weight: 500;
  color: #333;
  margin: 0;
`;
